import { ModalBackground, ModalCard } from "../hometab/styles";
// import file from "../../../assets/images/Image File.png";
import ImageIcon from "../../../assets/images/Image File.png";
import SubmitButton from "../../atoms/submitbutton";
import { useRef, useState } from "react";
import { Heading, Image, Upload, Input, Label } from "./styles";
import axios from "axios";
import { API_URL } from "../../../constants";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Spinner from "../../atoms/spinner";

interface ProfileProps {
  toggleClear: () => void;
  profile: any;
  refresh: boolean;
  setRefresh: any;
}
export function ProfileModal({ toggleClear, profile, refresh, setRefresh }: ProfileProps) {
  const imageSubmitRef = useRef<any>();
  const imageRef = useRef<any>();
  const [isloading, setisloading] = useState(false);
  const [imageloading, setImageloading] = useState(false);
  const [slugText, setSlugText] = useState(profile?.slug);
  const [brandName, setBrandName] = useState(profile?.name);

  let businessUuid = useSelector((state: any) => state.auth.uuid);
  const [errorMessage, setErrorMessage] = useState({
    brandName: {
      error: false,
      message: "",
    },
    brandSlug: {
      error: false,
      message: "",
    },
  });
  const [imageSize, setImageSize] = useState({
    message: "",
  });
  let [profileForm, setprofileForm] = useState<any>({});

  const handleImage = (event: any) => {
    event.preventDefault();
    let formData = new FormData();
    if (profileForm?.image?.name) {
      formData.append("image", profileForm.image, profileForm.image?.name);
    }
    if (profileForm?.image === null) {
      setImageSize({
        message: "Image required ",
      });
    } else if (profileForm?.image?.size >= 5000000) {
      setImageSize({
        message: "File is too large, Max allowed size is 5MB",
      });
    } else {
      setImageSize({
        message: "",
      });
    }

    formData.append("businessUuid", businessUuid);
    axios
      .post(`${API_URL}/update/profile/image`, formData)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success(response.data.message);
          setImageloading(false);
        }
      })
      .catch((error) => {
        setisloading(false);
        if (error?.response?.status === 400 || error?.response?.status === 401) {
          toast.error(error?.response?.data?.message);
          return;
        }
        toast.error("Connection Failed");
      });
  };

  const previewImage = (event: any) => {
    event.preventDefault();
    let reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        imageRef.current.src = reader.result;
        setprofileForm({ ...profileForm, image: event.target.files[0] });
        setTimeout(() => {
          setImageloading(true);
          imageSubmitRef.current.click();
        }, 500);
      }
    };
    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const handleChange = (event: any) => {
    const value = event.target.value;
    setSlugText(value?.toLowerCase());

    // if the lenght of the value is more than 3 fine the value on the server and set error value
    if (value.length >= 3) {
      const formData = {
        businessUuid: businessUuid,
        slug: value,
      };
      axios
        .post(`${API_URL}/is-slug-available `, formData)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            if (response.data.data.isSlugAvailable === false) {
              setErrorMessage({
                ...errorMessage,
                brandSlug: {
                  error: true, // Set error to true (or false as needed)
                  message: "Name already taken", // Update the message
                },
              });
            } else {
              // if the response is not 200 or 201 set error message
              setErrorMessage({
                ...errorMessage,
                brandSlug: {
                  error: false, // Set error to true (or false as needed)
                  message: response.data.message, // Update the message
                },
              });
            }
          }
        })
        .catch((error) => {
          setisloading(false);
          if (error?.response?.status === 400 || error?.response?.status === 401) {
            toast.error(error?.response?.data?.message);
            return;
          }
          toast.error("Connection Failed");
        });
    } else {
      // Reset the error message when the user types something new
      // if the value is empty set error message to empty
      setErrorMessage({
        ...errorMessage,
        brandSlug: {
          ...errorMessage.brandSlug,
          error: false, // Set error to true (or false as needed)
          message: "", // Update the message
        },
      });
    }
  };

  const createProductRequest = (e: any) => {
    e.preventDefault();
    setisloading(true);

    if (brandName === "" || slugText === "") {
      // if the brand name or slug is empty set error message
      if (brandName === "") {
        setErrorMessage({
          ...errorMessage,
          brandName: {
            error: true,
            message: "Brand Name is required",
          },
        });
      }
      if (slugText === "") {
        setErrorMessage({
          ...errorMessage,
          brandSlug: {
            error: true,
            message: "Brand Slug is required",
          },
        });
      }
      if (brandName === "" && slugText === "") {
        setErrorMessage({
          ...errorMessage,
          brandName: {
            error: true,
            message: "Brand Name is required",
          },
          brandSlug: {
            error: true,
            message: "Brand Slug is required",
          },
        });
      }

      setisloading(false);
      return;
    } else {


      // Check for spaces in slug
      if (/\s/.test(slugText)) {
        setisloading(false);
        setErrorMessage({
          ...errorMessage,
          brandSlug: {
            error: true,
            message: "Brand Slug cannot contain spaces",
          },
        });
        return; // Exit the function if an error is detected
      }



      // Check for disallowed characters in slug
      const disallowedCharsRegex = /[^a-z0-9-]/g; // Allow only letters, numbers, and hyphens
      if (disallowedCharsRegex.test(slugText)) {
        setisloading(false);
        setErrorMessage({
          ...errorMessage,
          brandSlug: {
            error: true,
            message: "Brand Slug can only contain letters, numbers, and hyphens",
          },
        });
        return; // Exit the function if an error is detected
      }




      // If validation passes, proceed with submission logic
      // ... (rest of your submission logic)

      if (errorMessage.brandSlug.error === true) {
        setisloading(false);
        return;
      }

      let formData: any = {
        name: brandName,
        slug: slugText,
        businessUuid: businessUuid,
      };



      // send the form data to the server
      axios
        .post(`${API_URL}/update/profile`, formData)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            setisloading(false);
            toast.success(response.data.message);
            setRefresh(!refresh);
            setSlugText("");
            toggleClear();
            setprofileForm({});
          }
        })
        .catch((error) => {
          setisloading(false);
          setprofileForm({});

          if (error?.response?.status === 400 || error?.response?.status === 401) {
            toast.error(error?.response?.data?.message);
            return;
          }
          toast.error("Connection Failed");
        });
      return;
    }
  };

  return (
    <ModalBackground onClick={toggleClear}>
      <ModalCard onClick={(event) => event.stopPropagation()}>
        <>
          <Heading>Basic Information</Heading>
          <form onSubmit={handleImage}>
            <Image>
              {imageloading && (
                <div className="absolute top-0 left-0 z-50 w-full h-full bg-gray-900 bg-opacity-50 flex justify-center items-center">
                  <Spinner />
                </div>
              )}
              <img src={profileForm?.image?.imageUrl || profile?.image || ImageIcon} alt="" ref={imageRef} />
              <input
                className="h-[100%] w-[100%] opacity-0  cursor-pointer absolute top-0 left-0 z-50 "
                type="file"
                // {...register("fileUpload")}
                onChange={previewImage}
                accept="image/*"
              />
              <input type="submit" value="save image" ref={imageSubmitRef} hidden={true} />
            </Image>
            {imageSize?.message && <p className="text-xs mb-2 text-red-600">{imageSize?.message}</p>}
            <Upload>Upload Logo</Upload>
          </form>
          <form onSubmit={createProductRequest}>
            <Input
              onChange={(e) => {
                setBrandName(e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  brandName: {
                    error: false,
                    message: "",
                  },
                });
              }}
              type="text"
              value={brandName}
              placeholder="Brand Name"
            />
            {errorMessage?.brandName.error && (
              <p className="text-xs mb-2 text-red-600">{errorMessage.brandName?.message}</p>
            )}
            <Label>www.path.ng /</Label>
            <Input onChange={handleChange} type="text" value={slugText} placeholder="yourname" />
            {errorMessage?.brandSlug.error && (
              <p className="text-xs mb-2 text-red-600">{errorMessage.brandSlug?.message}</p>
            )}
            <SubmitButton isloading={isloading} value="Save" width="19.6em" />
          </form>
        </>
      </ModalCard>
    </ModalBackground>
  );
}
